



























































import IconButton from "@/components/IconButton.vue";
import PageListView from "@/components/PageListView.vue";
import Vue from "vue";
import { ActionLog } from "../models";
import * as api from "../services/api";
import { t } from "@/plugins/i18n";

interface Data {
  logs: ActionLog[];
}

export default Vue.extend<Data, {}, {}, {}>({
  components: { PageListView, IconButton },

  data: () => ({
    logs: [],
  }),

  async beforeMount() {
    await api.getAll().then((result) => {
      this.logs = result?.map((x: ActionLog) => new ActionLog(x));
    });
  },

  methods: {
    async reload() {
      await api.getAll().then((result) => {
        this.logs = result?.map((x: ActionLog) => new ActionLog(x));
      });
    },
  },

  computed: {
    columns: () => [
      { width: 55, cell: "detailsButtonTemplate", sortable: false, filterable: false },
      {
        field: "tableName",
        title: t("ActionLog_ErintettTablaNeve"),
        headerClassName: "adjust_left",
        className: "adjust_left",
      },
      {
        field: "recordID",
        title: t("Azonosito"),
        headerClassName: "adjust_left",
        className: "adjust_left",
      },
      {
        field: "actionName",
        title: t("ActionLog_Akcio"),
        headerClassName: "adjust_left",
        className: "adjust_left",
      },
      {
        field: "insertUserName",
        title: t("ActionLog_AkciotVegrehajtotta"),
        headerClassName: "adjust_left",
        className: "adjust_left",
      },
      {
        field: "date",
        type: "date",
        format: "{0: yyyy. MM. dd. HH:mm:ss}",
        title: t("Datum"),
        headerClassName: "center_text adjust_center",
        className: "center_text adjust_center",
      },
    ],
  },
});
